import axios from 'axios'
import { Message } from 'element-ui';
import router from '../../../router/index'
import util from '../util/util'
import config from '../config'
import Vue from 'vue'

// 创建一个 axios 实例
const service = axios.create({
    withCredentials: true,
    baseURL: config.baseUrl + '/api/',
    timeout: 50000 // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
    config => {
        
        if(config.needAdmin !== false){
            config.url = 'front/' + config.url
        }
        config.method = config.isGet ? 'GET' : 'POST'

        let authToken = util.cacheGet("authToken");
        if(authToken) {
            config.headers['Authorization'] = authToken;
        }
        // config.headers['Authorization'] = 'efe935cc8d54bd1c5a1440fb8c36b581';
        config.headers['ShopId'] = util.cacheGet('shopId') ? util.cacheGet('shopId') : 0;
        return config
    },
    error => {
        // 发送失败
        // console.log(error)
        return Promise.reject(error)
    }
)

// 响应拦截器
service.interceptors.response.use(
    response => {

        if(response.data.status == 0){

            if(response.data.code == 90001 || response.data.code == 9999 ||  response.data.msg.indexOf("请先登录") >= 0){
                // 需要登录了！
                util.cacheSet("authToken", null);
                util.cacheSet('admin_login_messgae', '请先登录！');
                if(window.location.href.indexOf('/login') == -1){
                    router.push({
                        name: 'Login',
                    })
                }
            }else{
                 Message({
                    message: response.data.msg,
                    type: 'error'
                });                
            }
        }
        return response.data
    },
    error => {
        Message({
        	message: '系统错误！请联系管理员',
        	type: 'error'
        });
        if (error && error.response) {
            console.log(error.response)
        }
        return Promise.reject(error)
    }
)

export default service


// WEBPACK FOOTER //
// ./src/assets/js/api/index.js